import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { isLimitedContext } from 'selectors/siteContext'
import { getIsAdmin, getUserID } from 'selectors/user/session'
import { getLocation } from 'selectors/shared/location'
import { Actions as FlashMessageActions } from 'actions/shared/flashMessage'
import { Actions } from '../actions'
import Selectors from '../selectors'
import { getUserCollectionsUrl } from '../selectors/url'
import { getIdUserCollection } from '../selectors/collection'
const mapStateToProps = createStructuredSelector({
  actionLinks: Selectors.getAdminUrlLinks,
  collectionsUrl: getUserCollectionsUrl,
  hasValidPermissions: Selectors.getHasValidPermissions,
  idUserCollection: getIdUserCollection,
  isAdmin: getIsAdmin,
  isLimited: isLimitedContext,
  location: getLocation,
  userId: getUserID,
})

const mapDispatchToProps = (dispatch) => ({
  deleteCollection: () => dispatch(Actions.COLLECTION_ACTION_DELETE()),
  duplicateCollection: () => dispatch(Actions.COLLECTION_ACTION_DUPLICATE()),
  editCollection: () => dispatch(Actions.COLLECTION_ACTION_EDIT()),
  exportEmailsCollection: () => dispatch(Actions.COLLECTION_ACTION_EXPORT_EMAILS()),
  iosVirCollection: () => dispatch(Actions.COLLECTION_ACTION_IOS_VIR()),
  reorderCollection: () => dispatch(Actions.COLLECTION_ACTION_REORDER()),
  addMessage: (message, type) => {
    dispatch(
      FlashMessageActions.ADD({
        messages: [message],
        type: type,
      })
    )
  },
})

export type ConnectorProps = {
  actionLinks: Record<string, any>
  addMessage: (...args: Array<any>) => any
  collectionsUrl: string
  createCollection: (...args: Array<any>) => any
  deleteCollection: (...args: Array<any>) => any
  duplicateCollection: (...args: Array<any>) => any
  editCollection: (...args: Array<any>) => any
  exportEmailsCollection: (...args: Array<any>) => any
  hasValidPermissions: boolean
  idUserCollection: number
  iosVirCollection: (...args: Array<any>) => any
  isAdmin: boolean
  isLimited: boolean
  location: string
  reorderCollection: (...args: Array<any>) => any
  userId: number
}
export default connect(mapStateToProps, mapDispatchToProps) // Component Calls Connect
